import { render, staticRenderFns } from "./THGUserList.vue?vue&type=template&id=68509f52"
import script from "./THGUserList.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGUserList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports